module.exports = __webpack_public_path__ + "img/video.b5f5dce5.svg";